export enum EcommerceLocationSellerList {
	AlwaysTop = 0,
	AlwaysBottom = 1,
}
